<script>
	// Stores 
	import { textSite, linkWhatsappCondominio, linkAV, linkConheca, mailProposta } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';

	let items = [
		{
			icon: 'fas fa-hands-usd',
			title: 'Administração de Serviços e Recursos Financeiros do Condomínio',
			text: '<ul><li><p>Abertura de conta bancária em nome do condomínio, pagamento de taxas, contribuições, impostos, empregados e fornecedores.</p></li><li><p>Execução de reparos nas instalações do condomínio  (revisão anual de extintores, limpeza de caixa (s) da água, e outros).</p></li><li><p>Agenciamento de seguros, bem como comunicar e tratar de eventuais sinistros.</p></li><li><p>Reposição de gás e óleo diesel (em caso de serem centrais e existindo medidores individuais, serão executadas as leituras, rateio e cobrança destas taxas).</p></li><li><p>Elaboração de previsão orçamentária.</p></li><li><p>Emissão de boletos para  cobrança bancária  das cotas condominiais.</p></li></ul>'
		},
		{
			icon: 'fas fa-users',
			title: 'Departamento Pessoal',
			text: '<ul><li><p>Recrutamento e seleção de pessoal. Na contratação de funcionários, o síndico, se assim preferir, ocupa-se somente da escolha final dos candidatos.</p></li><li><p>Administração de pessoal, recolhimento de impostos.</p></li><li><p>Rescisão contratual incluindo homologação junto ao sindicato, agenciamento do PPP (Perfil Profissiográfico Previdenciário), incluindo implementação do EPI (Equipamentos de Proteção Individual), com consulta prévia ao síndico.</p></li></ul>'
		},
		{
			icon: 'fas fa-cabinet-filing',
			title: 'Organização e Arquivamento da Documentação do Condomínio',
			text: '<ul><li><p>Registros financeiros do condomínio, mês a mês, mantendo a documentação rigorosamente em dia, enviando demonstrativos de contas mensalmente aos condôminos, estando sempre à disposição do síndico e condôminos para informações.</p></li></ul>'
		},
		{
			icon: 'fas fa-building',
			title: 'Assessoria em Assembléias',
			text: '<ul><li><p>Convocação aos condôminos e elaboração de atas.</p></li></ul>'
		},
		{
			icon: 'fas fa-signal',
			title: 'Serviços Online',
			text: '<ul><li><p>Análise e impressão de balancetes mensais.</p></li><li><p>Impressão de 2ª via do boleto com a mensalidade do condomínio.</p></li></ul>'
		},
		{
			icon: 'fas fa-file-signature',
			title: 'Pedido de Proposta',
			text: '<ul><li><p>Havendo interesse na contratação dos serviços para administração, ficamos a disposição para a apresentação de proposta referente a honorários.</p></li><li><p>Os custos administrativos serão cobrados de acordo com a orientação fornecida pela AGADEMI (Associação Gaúcha do Mercado Imobiliário).</p></li><li><p>É importante ressaltar que nossa Administração não é simplesmente a emissão de bloquetos e confecção do movimento de caixa, é SIM administrar auxiliando o Síndico em todas as tarefas necessárias.</p></li></ul>'
		},
	];

</script>

<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container">
	<p class="text-center">
		Estamos prontos para assessorar as melhores soluções para o seu condomínio, confira os serviços:
	</p>

	<div class="grid grid-size--1 grid-size-sm--1">
		<div class="grid grid-size--2 grid-size-md--2 grid-size-sm--1 gap-20 text-center">
			{#each items as item, i}
			<div class="item item-list-circle background-gray round-all pa-20">
				<div class="flex flex-center">
					<div class="background-accent color-white circle r-75"><i class="{item.icon} fa-2x"></i></div>
				</div>
				<h5 class="text-bold pt-40">{item.title}</h5>
				<p style="text-align: left;">{@html item.text}</p>
			</div>
			{/each}
		</div>
		<hr>
		<div class="button text-center">        
			<a href="/solicite-proposta" use:link replace title="" class="btn btn-secondary">
				SOLICITE UMA PROPOSTA <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
			</a>
		</div>
		<br />
	</div>
</div>